export const isAlgo = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const version = urlParams.get('version')

    if (version === "algo") {
        return true;
    } else {
        return false;
    }
};